import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/admin/workorder/search_deposit',
      data
    });
  },
  ensureDeposit(id) {
    return http.post({
      url: '/admin/workorder/deposit_check_ok',
      data: { id },
      dataType: 'form'
    });
  },
  setDepositError(id) {
    return http.post({
      url: '/admin/workorder/deposit_check_fail',
      data: { id },
      dataType: 'form'
    });
  },
  resetDeposit(id) {
    return http.post({
      url: '/admin/workorder/deposit_reset',
      data: { id },
      dataType: 'form'
    });
  },
  setToErrList(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  cancelAudit(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form'
    });
  },
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getUserRecords(data) {
    return http.get({
      url: '/admin/workorder/findByUse/Forward',
      data: {
        useId: data.userId,
        page: data.page,
        size: data.size
      }
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/admin/bill/types'
    });
  },
  updateFreeze(id) {
    return http.post({
      url: '/admin/workorder/freeze_withdraw',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  cancel(id) {
    return http.post({
      url: '/admin/workorder/cancel_withdraw',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  sendTheWithdrawalTrans(data) {
    return http.post({
      url: '/admin/workorder/handed_network_withdraw',
      data: {
        networkId: data.transId,
        id: data.id
      },
      dataType: 'form'
    });
  },
  getUserWallet(id) {
    return http.get({
      url: '/admin/workorder/findByUse/wallet',
      data: {
        userId: id
      }
    });
  },
  remark(data) {
    return http.get({
      url: '/admin/workorder/add/remark',
      data
    });
  },
  manualConfirm(id) {
    return http.post({
      url: '/admin/workorder/manual_confirm',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  returnToNotApproved(id) {
    return http.post({
      url: '/admin/workorder/return_to_not_approved',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
